import { render, staticRenderFns } from "./GraphDetail90.vue?vue&type=template&id=22c4a433&scoped=true"
import script from "./GraphDetail90.vue?vue&type=script&lang=js"
export * from "./GraphDetail90.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4a433",
  null
  
)

export default component.exports